export default __webpack_public_path__ + "static/media/mic-off(white).1cb82921.svg";